import { ComposerActions } from 'components/composer/composer-actions';
import { ComposerAssistantControl } from 'components/composer/composer-control';
import { ComposerModelAction } from 'components/composer/composer-model-action';
import { ComposerPlanAction } from 'components/composer/composer-plan-action';
import { ComposerVoiceAction } from 'components/composer/composer-voice-action';

const ComposerFooter = ({
	type = 'app',
	disabled = false,
	canManagePreferences = false,
	canManageProjectDefaults = false,
	rootApi = undefined,
	modelDisabled = false,
	model,
	onModelSelect,
	onPreferencesChange,
	preferences,
	connectors,
	onDraftPreferencesChange,
	onDraftConnectorsChange,
	onPlanModeChange,
	onVoiceStart,
	deliveryMode = 'queue',
	onDeliveryModeChange,
	modeDisabled = false,
	planMode = false,
}) => {
	return (
		<footer className='flex-between gap-3 px-3 pb-3 pt-1'>
			<div className='flex-start gap-2'>
				<ComposerActions
					type={type}
					disabled={disabled}
					canManagePreferences={canManagePreferences}
					canManageProjectDefaults={canManageProjectDefaults}
					rootApi={rootApi}
					onPreferencesChange={onPreferencesChange}
					preferences={preferences}
					connectors={connectors}
					onDraftPreferencesChange={onDraftPreferencesChange}
					onDraftConnectorsChange={onDraftConnectorsChange}
					deliveryMode={deliveryMode}
					onDeliveryModeChange={onDeliveryModeChange}
					modeDisabled={modeDisabled}
				/>
				<ComposerModelAction disabled={disabled || modelDisabled} model={model} onSelect={onModelSelect} />
			</div>
			<div className='flex-start gap-2'>
				{type !== 'agent' ? (
					<ComposerPlanAction
						disabled={disabled || modeDisabled}
						planMode={planMode}
						onPlanModeChange={onPlanModeChange}
					/>
				) : null}
				<ComposerVoiceAction disabled={disabled} onClick={onVoiceStart} />
				<ComposerAssistantControl disabled={disabled} />
			</div>
		</footer>
	);
};

export { ComposerFooter };
